import { useMutation } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';
import { refetchQueryGetRecurringExportsQuery } from 'features/Accounting/pages/ExportsHome/hooks/useGetRecurringExports';

import { DeleteRecurringExportDocument } from './deleteRecurringExport.gql';

const useDeleteRecurringExport = (accountingRecurringExportId: string) => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error(
      'companyProfileId is undefined in useDeleteRecurringExport',
    );
  }

  return useMutation(DeleteRecurringExportDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [
      refetchQueryGetRecurringExportsQuery({ companyProfileId }),
    ],
    variables: { input: { accountingRecurringExportId } },
  });
};

export default useDeleteRecurringExport;
